<script setup lang="ts">
defineProps<{ data: SectionTitleProps; template?: 'page' | 'overlay' }>()

// ------- GSAP ANIMATION -------
const { $gsap, $ScrollTrigger } = useNuxtApp()
const section = ref<HTMLElement | null>(null)
const title = ref<HTMLElement | null>(null)
const border = ref<HTMLElement | null>(null)
const indicator = ref<HTMLElement | null>(null)

async function cleanupAnimation(): Promise<void> {
  $ScrollTrigger.getById('section-title-reveal')?.kill()

  await Promise.resolve()
}

async function initAnimation() {
  if (!section.value) return
  const tl = $gsap.timeline({
    scrollTrigger: {
      id: 'section-title-reveal',
      trigger: section.value,
      scroller: document.querySelector('#overlay') ?? null,
      // markers: true,
      start: `top 90%`,
      end: `bottom top`,
      toggleActions: 'play reverse play reverse',
    },
  })
  tl.fromTo(
    border.value,
    {
      scaleX: 0,
    },
    {
      scaleX: 1,
      transformOrigin: 'center center',
      ease: 'power2.inOut',
    },
  )
    .fromTo(
      title.value,
      {
        clipPath: 'polygon(-100% 0%, 0% 0%, -05% 100%, -100% 100%)',
      },
      {
        clipPath: 'polygon(-100% 0%, 105% 0%, 100% 100%, -100% 100%)',
        ease: 'power2.inOut',
      },
      '<',
    )
    .fromTo(
      indicator.value,
      {
        clipPath: 'polygon(-100% 0%, 0% 0%, -05% 100%, -100% 100%)',
      },
      {
        clipPath: 'polygon(-100% 0%, 105% 0%, 100% 100%, -100% 100%)',
        ease: 'power2.inOut',
      },
      '-=0.1',
    )
}

onMounted(async () => {
  await nextTick()
  await cleanupAnimation()
  await initAnimation()
})

onBeforeUnmount(async () => {
  await cleanupAnimation()
})
</script>

<template>
  <section
    ref="section"
    class=""
    :class="{
      'bg-white': template !== 'page' && template !== 'overlay' && data.theme !== 'light-grey',
      'bg-light-grey':
        template === 'page' || (template !== 'overlay' && data.theme === 'light-grey'),
    }"
  >
    <div
      class="mx-bleed relative my-5 mt-16 flex justify-between pt-4 font-mono text-sm uppercase select-none"
    >
      <div
        ref="border"
        class="line-border absolute top-0 left-0 h-[1px] w-full origin-center bg-black/50"
      />
      <h2 ref="title">{{ data.title }}</h2>
      <p ref="indicator">{{ data.indicator }}</p>
    </div>
  </section>
</template>
